import { autorun } from 'mobx';
import { useCallback, useEffect, useState } from 'react';

import useStores from 'hooks/use-stores';

interface LicenseInfo {
    canUpgrade: boolean;
    isTrial: boolean;
}

export default function useLicenseInfo() {
    const { userStore } = useStores();

    const getValue = useCallback(
        (): LicenseInfo => ({
            isTrial: userStore.user.isAnonymous || userStore.hasOnlyFreeLicense,
            canUpgrade: userStore.hasTrialLicense && userStore.hasFreeLicense && !userStore.hasLicense
        }),
        [userStore]
    );

    const [licenseInfo, setLicenseInfo] = useState(getValue);
    useEffect(() => autorun(() => setLicenseInfo(getValue())), [getValue]);

    return licenseInfo;
}
